export const GET_AUTOMATED_RULES = gql`
  query GET_AUTOMATED_RULES(
    $pageInfo: PageInfoInput
    $filters: AutomatedRuleFiltersInput
  ) {
    automatedRules(pageInfo: $pageInfo, filters: $filters) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        automatedRuleId
        name
        createdAt
        updatedAt
        status
        createdById
        frequency
        frequencyInterval
        triggerDelayType
        triggerDelay
        executionLimit
        conditions {
          conditionId
          key
          value
          stepType
          stepStatus
          customStepId
          customStep {
            label
          }
          tag {
            tagId
            label
            status
          }
        }
        actions {
          actionId
          actionType
          textTemplateId
          emailTemplateId
          documentTemplatePackageId
          packageId
          applicantStage
          hiringStage
          leadEmployeeId
          leadEmployee {
            employeeId
            firstName
            lastName
          }
          memberEmployeeIds
          memberEmployees {
            employeeId
            firstName
            lastName
          }
          textTemplate {
            title
          }
          emailTemplate {
            title
          }
          documentTemplatePackage {
            packageName
          }
          voiceAgent {
            voiceAgentId
          }
          taskTemplate {
            title
          }
          noteTemplate {
            title
          }
          training {
            name
          }
          course {
            name
          }
          package {
            name
          }
        }
        createdBy {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const GET_AUTOMATED_RULE = gql`
  query GET_AUTOMATED_RULE($automatedRuleId: String!) {
    automatedRule(automatedRuleId: $automatedRuleId) {
      automatedRuleId
      name
      createdAt
      updatedAt
      status
      conditions {
        conditionId
        key
        value
        stepType
        stepStatus
        customStepId
        customStep {
          label
        }
        tag {
          tagId
          label
          status
        }
      }
      actions {
        actionId
        actionType
        textTemplateId
        documentTemplatePackageId
        packageId
        trainingId
        courseId
        applicantStage
        disqualifiedReason
        terminatedReason
        notInterestedReason
        voiceAgentId
        hiringStage
        emailTemplateId
        taskTemplateId
        noteTemplateId
        leadEmployeeId
        leadEmployee {
          employeeId
          firstName
          lastName
        }
        memberEmployeeIds
        memberEmployees {
          employeeId
          firstName
          lastName
        }
      }
      activeHours {
        activeHoursId
        dayOfWeek
        startMinute
        endMinute
      }
      frequency
      frequencyInterval
      triggerDelayType
      triggerDelay
      executionLimit
      createdById
      createdBy {
        employeeId
        firstName
        lastName
      }
      companyId
    }
  }
`

export const CREATE_AUTOMATED_RULE = gql`
  mutation CREATE_AUTOMATED_RULE($input: AutomatedRuleInput!) {
    createAutomatedRule(input: $input) {
      automatedRuleId
      name
      createdAt
      updatedAt
      status
    }
  }
`

export const EDIT_AUTOMATED_RULE = gql`
  mutation EDIT_AUTOMATED_RULE(
    $automatedRuleId: String!
    $input: AutomatedRuleInput!
  ) {
    updateAutomatedRule(automatedRuleId: $automatedRuleId, input: $input) {
      automatedRuleId
      name
      createdAt
      updatedAt
      status
    }
  }
`

export const SET_AUTOMATED_RULE_STATUS = gql`
  mutation SET_AUTOMATED_RULE_STATUS(
    $automatedRuleId: String!
    $status: AutomatedRuleStatus!
  ) {
    setAutomatedRuleStatus(automatedRuleId: $automatedRuleId, status: $status) {
      automatedRuleId
      name
      createdAt
      updatedAt
      status
    }
  }
`

export const DELETE_AUTOMATED_RULE = gql`
  mutation DELETE_AUTOMATED_RULE($automatedRuleId: String!) {
    deleteAutomatedRule(automatedRuleId: $automatedRuleId) {
      automatedRuleId
      name
      createdAt
      updatedAt
      status
    }
  }
`

export const GET_FREQUENCY_DEFAULTS = gql`
  query GetAutomatedRuleFrequencyDefaults {
    automatedRuleFrequencyDefaults {
      frequency
      defaultExecutionLimit
    }
  }
`
